const DiseaseMaster = {

    // FIELDS
    "disease_name": "Disease Name",
    "corrective_action": "Corrective Action",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "diseaseMaster": "Disease Master",

    // ERROR
    "error_disease_name": "Enter Disease Name",
    "error_corrective_action": "Enter Corrective Action",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_disease_name": 'DISEASE NAME',
    "table_corrective_action": 'CORRECTIVE ACTION',
    "table_status": "STATUS",

}

export default DiseaseMaster;
